import { IDevice } from 'lavva.exalushome/build/js/Services/Devices/IDevice';
import { IDeviceChannel } from 'lavva.exalushome/build/js/Services/Devices/IDeviceChannel';
import { IDeviceTask } from 'lavva.exalushome/build/js/Services/Devices/IDeviceTask';
import { SetLightBrightness } from 'lavva.exalushome/build/js/Services/Devices/Tasks/Tasks';
import { useNative } from '../../../../../hooks/native/use-native';
import { useExalusServicesContext } from '../../../context/services';

export const useCentralActionLightControl = (channels: IDeviceChannel[]) => {
  const { devicesApi } = useExalusServicesContext();
  const { fireVibration } = useNative();

  const handleAction = async (brightness?: number) => {
    fireVibration();

    const mappedChannels: [Device: IDevice, Task: IDeviceTask][] = channels.map((channel) => {
      const task = new SetLightBrightness();
      task.DeviceGuid = channel.GetDevice().Guid;
      task.Channel = channel.Number;
      if (typeof brightness === 'number' && brightness >= 0) {
        task.Brightness = brightness;
      }

      return [channel.GetDevice(), task];
    });

    return await devicesApi.ExecuteDevicesTasksAsync(mappedChannels);
  };

  const handleSliderEvent = (value: number) => handleAction(value);

  return { handleAction, handleSliderEvent };
};
